import * as actionTypes from 'store/actions/actionTypes';

const initState = {
  loading: false,
  product_types: [],
};

export default (state = initState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PRODUCT_TYPES_START:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.FETCH_PRODUCT_TYPES_END:
      return {
        ...state,
        loading: false,
        product_types: action.data.product_types,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/product_type.js